import { AcademicInterest, Activity, Experience, Language, PersonalInterest, Student } from "../../../api/client";
import { EntireFormInterface } from "./Helpers";

export function constructSubmitValue(values: EntireFormInterface): Student {
  let submitValue = new Student({
    // Basic information
    preferredName: values.preferredName,
    preferredPronouns: Number(values.preferredPronouns),
    expectedGraduationSemester: Number(values.graduationSemester),
    expectedGraduationYear: Number(values.graduationYear),
    linkedinProfile: values.linkedinProfile,
    isHonorsStudent: values.studentClassification.includes('Honors College Student'),
    isInternationalStudent: values.studentClassification.includes('International Student'),
    isTransferStudent: values.studentClassification.includes('Transfer Student'),
    isPellGrantRecipient: values.studentClassification.includes('Pell Grant Recipient'),
    isNationalMeritScholar: values.scholarshipPrograms.includes('National Merit Scholar'),
    isHonorsDepartmentProgram: values.studentClassification.includes('Departmental Honors Program(s)'),
    wilcoxScholars: values.scholarshipPrograms.includes('Wilcox Scholars'),
    kosoveSociety: values.scholarshipPrograms.includes('Kosove Society'),
    peaceCorpPrep: values.scholarshipPrograms.includes("Peace Corp Prep"),
    futureStrategies: values.scholarshipPrograms.includes("GNSI Future Strategists"),
    isUndergraduateStudent: values.isUndergraduate == "1",
    // Interests and activities goals
    academicInterests: values.academicInterestsList.map((interest: string) => (new AcademicInterest({ name: interest }))),
    personalInterests: values.personalInterestsList.map((interest: string) => (new PersonalInterest({ name: interest }))),
    currentActivities: values.activityList.map((activity: string) => (new Activity({ name: activity }))),
    gradSchoolPlans: Number(values.gradSchoolPlans),
    gradSchoolAbroadPlans: Number(values.gradProgramsAbroadInterest),
    futureGoals: values.futureGoals,
    passionProjects: values.passionProjects,
    knowsAboutHIPS: Number(values.knowsHipsValue),
    speakForeignLanguageList: values.languagesSpokenList
      .filter(language => language !== "n/a")
      .map((language: string) => new Language({ name: language })),
    experienceList: values.experienceList.map((experience: Experience) => {return new Experience({
      ...experience,
      type: Number(experience.type)
    })})
  });
  return submitValue
}

